import "./assets/styles/styles.scss";
import { Utils } from "./utils/utils";
import { brandConfig } from "./brandConfig";
import brandStyle from "./config/brandWiseStyle";
declare global {
    interface Window {
        ratingReview: any;
        kritiqueInitialized: boolean;
        rrWidgetConfig: any;
        ctConstants: any;
        digitalData: any;
    }
}

window.ratingReview = window.ratingReview || {};
window.rrWidgetConfig = window.rrWidgetConfig || {};
window.ctConstants = window.ctConstants || {};
window.digitalData = window.digitalData || {};
 
export class rrWidget {
    BILibLoaded;
    public brand;
    public locale;
    public apikey;
    public kqOpen;
    public observer;
    public destroyObserver;
    public initWidgetComponent;
    public iterateAndInitializeAllWidget;
    public removeDataAddedAttribute;

    constructor(public sortby: string = 'createdDate desc',
        public langaugeby: string = '',
        public filterby: string = '',
        public filterQuestionByImg: boolean = false,
        public sortbyQuestion: string = 'createdDate desc',
        public pageNumber: number = 0,
        public quesPgNum: number = 0,
        public filterByImg: boolean = false,
        // public questionCount: number = 0,
        public size: number = 10) {
        this.langaugeby = langaugeby
        this.sortby = sortby;
        this.pageNumber = pageNumber;
        this.quesPgNum = quesPgNum;
        this.size = size;
        this.filterby = filterby;
        this.filterQuestionByImg = filterQuestionByImg;
        this.sortbyQuestion = sortbyQuestion;
        this.filterByImg = filterByImg;
        this.BILibLoaded = false;
        this.observer = new MutationObserver((mutations) => {
            let self = this;
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes') {
                    switch (mutation.attributeName) {
                        case "data-entity-id":
                            let nestedELems = document.querySelectorAll('.rr-widget-container, .kr-widget-container');
                            self.removeDataAddedAttribute(nestedELems);
                    }
                } else if (mutation.type === 'childList') {
                    if (mutation.addedNodes.length > 0) {
                        // mutation addedNodes contains list of changed nodes
                        mutation.addedNodes.forEach(item => {
                            let element = item as HTMLElement;
                            if (element.classList && (element.classList.contains('rr-widget-container') || element.classList.contains('kr-widget-container'))) {
                                self.initWidgetComponent(element);
                            } else if (element.childNodes.length > 0 && (element.querySelector('.rr-widget-container') || element.querySelector('.kr-widget-container'))) {
                                let nestedELems = element.querySelectorAll('.rr-widget-container, .kr-widget-container');
                                self.iterateAndInitializeAllWidget(nestedELems);
                            } else if (mutation.target && ((mutation.target as HTMLElement).querySelector('.rr-widget-container') || (mutation.target as HTMLElement).querySelector('.kr-widget-container'))) {
                                let nestedELems = (mutation.target as HTMLElement).querySelectorAll('.rr-widget-container, .kr-widget-container');
                                self.iterateAndInitializeAllWidget(nestedELems);
                            } else {
                                let nestedELems = document.querySelectorAll('.rr-widget-container, .kr-widget-container');
                                self.iterateAndInitializeAllWidget(nestedELems);
                            }
                        });
                    }
                }
            });
        });
        this.initWidgetComponent = (element) => {
            if (element.dataset['summaryTemplate']) {
                this.ratingSummaryPanel([element]);
            } else if (element.dataset['readpanelTemplate']) {
                // this.questionPanel(element);
                this.readPanel(element);
            }
        };
        this.destroyObserver = () => {
            this.observer.disconnect();
        }
        this.iterateAndInitializeAllWidget = (nestedELems) => {
            let self = this;
            nestedELems.forEach((elem) => {
                if (!(elem as HTMLElement).getAttribute('data-added')) {
                    self.initWidgetComponent((elem as HTMLElement));
                }
            })
        }
        this.removeDataAddedAttribute = (nestedELems) => {
            let self = this;
            nestedELems.forEach((elem) => {
                if ((elem as HTMLElement).getAttribute('data-added')) {
                    (elem as HTMLElement).removeAttribute('data-added');
                }
            })
        }
    }

    private async ratingSummaryPanel(elements: HTMLElement[]) {
        const ratingSummaryClass = await import("./ratings/ratingSummary");
        const ratingSummaryObj = new ratingSummaryClass.RatingSummary();
        ratingSummaryObj.observeRatingSummary(elements, this.brand, this.locale);
    }

    private async inlineWidgetPanel(elements: HTMLElement[]) {
        const inlineWidgetClass = await import("./inlineWidget/inlineWidget");
        const inlineWidgetObj = new inlineWidgetClass.inlineWidget();
        inlineWidgetObj.observeinlineWidgetClass(elements, this.brand, this.locale);
    }

    private async readPanel(element: HTMLElement) {
        const readPanelClass = await import("./readPanel/readPanel");
        const readPanelObj = new readPanelClass.ReadPanel();
        let page = Utils.getPageNumber()
        if (page > 0) {
            this.pageNumber = Utils.getPageNumber() - 1
        } else {
            this.pageNumber = Utils.getPageNumber()
        }
        readPanelObj.observeReadPanel(element, this.brand, this.locale, this.filterby, this.sortby, this.langaugeby, this.filterByImg, this.pageNumber, this.size, false, false);
    }
    async questionPanel(element: HTMLElement) {
        const readQuestionClass = await import("./question/questionReadPanel/questionReadPanel");
        const readQuestionClassObj = new readQuestionClass.QuestionReadPanel();
        let page = Utils.getPageNumber()
        if (page > 0) {
            this.quesPgNum = Utils.getPageNumber() - 1
        } else {
            this.quesPgNum = Utils.getPageNumber()
        }
        readQuestionClassObj.getQuestionReadPanelTemplate(element, this.brand, this.locale, this.sortby, this.filterQuestionByImg, this.quesPgNum, this.size, false);
    }

    setObserverForRating() {
        let list = document.querySelector('body');
        this.observer.observe(list, {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: false,
            attributeFilter: ['data-entity-id'],
        });
    }
    addListenerForWritePanel() {
        const el = document.querySelector('[data-readpanel-template]') as HTMLElement;
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        var counter = 0;
        let value = setInterval(() => {
            const $writeButton = document.querySelector('.write-review-btn') as HTMLElement;
            if ($writeButton && counter <= 15) {
                counter = 20;
                $writeButton.click();
                clearInterval(value);
            }
        }, 2500);
    }

    private async getWidgetConfig() {
        const readPanelClass = await import("./readPanel/readPanel");
        const readPanelObj = new readPanelClass.ReadPanel();
        await readPanelObj.getWidgetConfiguration(this.brand, this.locale, this.apikey);
    }

    initializeWidgets() {
        this.setHeadStyleRootAttribute();
        this.getWidgetConfig().then(() => {
            if (window.rrWidgetConfig.apiKey) {
                let widgetElement = document.querySelector('[data-readpanel-template]') as HTMLElement;
                if (widgetElement) {
                    // this.questionPanel(widgetElement);
                    this.readPanel(widgetElement);
                }
                let inlineFormElements = <HTMLElement[]>Array.prototype.slice.call(document.querySelectorAll('[data-inline-template]'));
                if (inlineFormElements) {
                    this.inlineWidgetPanel(inlineFormElements);
                }
                let summaryElements = <HTMLElement[]>Array.prototype.slice.call(document.querySelectorAll('[data-summary-template]'));
                if (summaryElements && summaryElements.length > 0) {
                    this.ratingSummaryPanel(summaryElements);
                }
                this.setObserverForRating();
            } else {
                console.log('Widget configuration not found');
            }
        });
    }

    setHeadStyleRootAttribute() {
        let krInlineStyleForRoot = document.createElement('style'),
            prevPageForRoot = document.createElement('link'),
            nextPageForRoot = document.createElement('link'),
            nextLink = '',
            prevLink = '',
            headSelector = document.querySelector('head');
        krInlineStyleForRoot.setAttribute('id', 'kr-root-style-params');
        prevPageForRoot.setAttribute('rel', 'prev');
        nextPageForRoot.setAttribute('rel', 'next');
        if (rrWidget.prototype.pageNumber) {
            let splittedHref = window.location.href.split('?')
            if (splittedHref[1]) {
                let splittedHrefQueryParams = splittedHref[1].split("&");

                // // Split each key=value into array, the construct js object

                let p = {};
                for (let j = 0; j < splittedHrefQueryParams.length; j++) {
                    let kv = splittedHrefQueryParams[j].split("=");
                    p[kv[0]] = kv[1];
                }
                let nextLinkObj = {
                    ...p,
                    kqstate: 'pg:' + (rrWidget.prototype.pageNumber + 2)
                }
                let nextLinkStr = ''
                for (const property in nextLinkObj) {
                    nextLinkStr += property + "=" + nextLinkObj[property] + "&"
                }
                nextLink = window.location.href + "?" + nextLinkStr.slice(0, -1);
                if (rrWidget.prototype.pageNumber > 0) {
                    let prevLinkObj = {
                        ...p,
                        kqstate: 'pg:' + (rrWidget.prototype.pageNumber)
                    }
                    let prevLinkStr = ''
                    for (const prevProperty in prevLinkObj) {
                        prevLinkStr += prevProperty + "=" + prevLinkObj[prevProperty] + "&"
                    }
                    prevLink = window.location.href + "?" + prevLinkStr.slice(0, -1);
                }
            } else {
                nextLink = window.location.href + "?kqstate=pg:" + (rrWidget.prototype.pageNumber + 1);
                if (rrWidget.prototype.pageNumber > 0) {
                    prevLink = window.location.href + "?kqstate=pg:" + (rrWidget.prototype.pageNumber - 1);
                }
            }
        } else if (this.pageNumber >= 0) {
            let splittedHref = window.location.href.split('?')
            if (splittedHref[1]) {
                if (this.pageNumber == 0) {
                    nextLink = window.location.href + "&kqstate=pg:" + (this.pageNumber + 2);
                } else {
                    nextLink = window.location.href + "&kqstate=pg:" + (this.pageNumber + 1);
                }
                if (this.pageNumber > 0) {
                    prevLink = window.location.href + "&kqstate=pg:" + (this.pageNumber - 1);
                }
            } else {
                nextLink = window.location.href + "?kqstate=pg:" + (this.pageNumber + 1);
                if (this.pageNumber > 0) {
                    prevLink = window.location.href + "?kqstate=pg:" + (this.pageNumber - 1);
                }
            }
        }
        prevPageForRoot.setAttribute('href', prevLink);
        nextPageForRoot.setAttribute('href', nextLink);
        let brandLocaleKey = this.brand + "-" + this.locale;
        if (brandStyle.hasOwnProperty(brandLocaleKey)) {
            krInlineStyleForRoot.innerHTML = brandStyle[brandLocaleKey];
        } else {
            krInlineStyleForRoot.innerHTML = brandStyle[this.brand]
        }
        if (headSelector) {
            headSelector.insertBefore(prevPageForRoot, headSelector.firstChild);
            headSelector.insertBefore(nextPageForRoot, headSelector.firstChild);
            headSelector.insertBefore(krInlineStyleForRoot, headSelector.firstChild);
        }
    }

}

const main = () => {
    if (window.kritiqueInitialized) return;
    const rrWidgetObj = new rrWidget();
    let searchParam = new URLSearchParams(window.location.search);
    let getParams = Utils.getScriptParams();
    if (getParams.hasOwnProperty('brand') || getParams.hasOwnProperty('brandid')) {
        rrWidget.prototype.brand = getParams['brandid'] ? getParams['brandid'] : getParams['brand'];
        brandConfig.brand = rrWidget.prototype.brand;
    }
    if (getParams.hasOwnProperty('locale') || getParams.hasOwnProperty('localeid')) {
        //Services expect locale as lowercase, storing locale in lowercase
        rrWidget.prototype.locale = `${getParams['localeid'] ? getParams['localeid'] : getParams['locale']}`.toLowerCase();
        brandConfig.locale = rrWidget.prototype.locale;
    }
    if (getParams.hasOwnProperty('apikey')) {
        rrWidget.prototype.apikey = getParams['apikey'];
        brandConfig.apikey = rrWidget.prototype.apikey;
    }
    if (searchParam.has('kq-open') || searchParam.has('kqopen')) {
        rrWidget.prototype.kqOpen = searchParam.has('kqopen') ? searchParam.get('kqopen') : searchParam.get('kq-open');
        rrWidget.prototype.addListenerForWritePanel();
    }

    // here get page number from site url

    let page = Utils.getPageNumber()
    if (page > 0) {
        rrWidget.prototype.pageNumber = Number(page) - 1;
    }
    if (document.readyState === "complete") {
        console.log('DOM Load complete');
        rrWidgetObj.initializeWidgets();
        window.kritiqueInitialized = true;
    } else {
        window.addEventListener('load', (event) => {
            console.log('DOM fully loaded and parsed');
            rrWidgetObj.initializeWidgets();
            window.kritiqueInitialized = true;
        });
    }
}

main();
